const getCurrentRouteInstance = (route) => {
  const { matched } = route;
  if (matched?.length) {
    const { instances } = matched[matched.length - 1];
    if (instances) {
      return instances.default || instances;
    }
  }
};

export default (from, to) => {
  const name = typeof from.meta.micro === 'string' ? from.meta.micro : from.name;
  const toName = typeof to.meta.micro === 'string' ? to.meta.micro : to.name;
  const microApp = document.querySelector(`#micro-app_${name} #app`)?.__vue__;
  if (!microApp) {
    return Promise.resolve(true);
  }
  // 从子应用路由过来的，由子应用自己处理
  if (name === toName && to.path.endsWith(microApp.$route.path)) {
    return Promise.resolve(true);
  }
  const instance = getCurrentRouteInstance(microApp.$route);
  const fns = instance?.$options?.beforeRouteLeave;
  if (fns && fns[0]) {
    return new Promise((resolve, reject) => {
      Reflect.apply(fns[0], instance, [to, from, r => {
        if (r instanceof Error) {
          reject(r);
          return;
        }
        resolve(r);
      }, true]);
    });
  }
  return Promise.resolve(true);
};
